import { Skill } from 'client/model/skill';
import { Operation } from '../model/operation';

export const getLastOperation = (operations: Operation[], skillId: string) =>
    operations.find((operation) => operation.itemId === skillId);

export const getIsArabicSkillName = (skill: Skill) => {
    const skillName = skill.onAir ? skill.name : skill.draft.name;
    let isArabicSkillName = false;
    if (skill?.draft?.publishingSettings && 'multilingualSettings' in skill.draft.publishingSettings) {
        const arabicSkillName = skill.draft.publishingSettings.multilingualSettings?.['ar']?.name;
        isArabicSkillName = skillName === arabicSkillName;
    }
    return isArabicSkillName;
};
